export const availableLanguages = {
  ru: 'Русский',
  en: 'Английский',
  de: 'Немецкий',
  es: 'Испанский',
  ja: 'Японский',
  bg: 'Болгарский',
  da: 'Датский',
};
